// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-page-settings .v-list--three-line .v-list__tile{height:auto!important;min-height:88px}", ""]);
// Exports
module.exports = exports;
